<template>
    <div>
        <el-tabs type="border-card" v-model="activeName" class="cust-tabs" @tab-click="handleClick">
            <el-tab-pane :label="$t('Dashboard')" v-if="$store.state.config.user.role_slug.indexOf('fachstellen') >= 0" name="dashboard">
                <dashboard v-if="dashboardShow"></dashboard>
            </el-tab-pane>
            <el-tab-pane :label="$t('Details')" v-if="$store.getters.getConfig('has_permissions').includes('fachstellens-show')" name="detail">
                <fachstellen-details v-if="detailShow" :fachstellen_slug="$route.params.fachstellen_slug || fachstellen_slug"/>
            </el-tab-pane>
            <el-tab-pane :label="$t('Cases')" v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-index')" name="case">
                <cases ref="cases" v-if="caseShow" :fachstellen_slug="$route.params.fachstellen_slug || fachstellen_slug" />
            </el-tab-pane>
            <el-tab-pane :label="$t('Godchild')" v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-show')" name="patenkinder">
                <fachstellen-patenkinder v-if="pShow" :fachstellen_slug="$route.params.fachstellen_slug || fachstellen_slug"/>
            </el-tab-pane>
            <el-tab-pane :label="$t('Contacts')" v-if="$store.getters.getConfig('has_permissions').includes('fachstellen-users-getFachstellenUsers')" name="contact">
                <fachstellen-contacts v-if="contactShow" :fachstellen_slug="$route.params.fachstellen_slug || fachstellen_slug"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import EnjoyHint from 'enjoyhint';

    import Vue from 'vue';
    import Dashboard from './DashboardTab'
    import FachstellenContacts from './Contact'
    import FachstellenDetails from './FachstellenDetails'
    import FachstellenPatenkinder from '../Patenkinder/Patenkinder'
    import Cases from '../Cases/Cases'

    export default {
        components: {
            'dashboard': Dashboard,
            "fachstellen-contacts": FachstellenContacts,
            'fachstellen-details': FachstellenDetails,
            'fachstellen-patenkinder': FachstellenPatenkinder,
            'cases': Cases,
        },
        props: {
            fachstellen_slug: String
        },
        created() {
            this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been re-rendered
                if(this.$store.state.config.user.role_slug.indexOf('fachstellen') >= 0 && this.$store.state.config.user.tour_visited == '0')
                    this.runEnjoyHint();
            })
        },
        mounted() {
            this.activeTab(this.activeName);
            serverBus.$on("runHelpTour", status => {
                if(status) {
                    this.runEnjoyHint();
                }
            });
        },
        data() {
            return {
                activeName: (this.$route.query.at) ? this.$route.query.at : (this.$store.state.config.user.role_slug.indexOf('fachstellen') >= 0 ? 'dashboard' : 'detail' ),
                dashboardShow: true,
                detailShow: false,
                caseShow: false,
                pShow: false,
                contactShow: false,
                enjoyhint_instance: null
            };
        },
        methods: {
            handleClick(tab, event) {
                this.activeTab(tab.name)
            },
            activeTab(tab) {
                var self = this;

                self.dashboardShow = false;
                self.detailShow = false;
                self.caseShow = false;
                self.pShow = false;
                self.contactShow = false;
                if(tab == "dashboard") {
                    if (this.$route.query.at)
                        this.$router.replace('/dashboard');
                    
                    Vue.nextTick(function (){
                        self.dashboardShow = true;
                    });
                } else if(tab == "detail") { 
                    Vue.nextTick(function (){
                        self.detailShow = true;
                    });
                } else if(tab == "case") {

                    Vue.nextTick(function (){
                        self.caseShow = true;
                    });
                } else if(tab == "patenkinder") {

                    Vue.nextTick(function (){
                        self.pShow = true;
                    });
                } else if(tab == "contact") {

                    Vue.nextTick(function (){
                        self.contactShow = true;
                    });
                }
            },
            runEnjoyHint() {
                var options = {
                    onStart: function () {
                        $('body').css({'overflow':'hidden'});
                    }
                };
                this.enjoyhint_instance = new EnjoyHint(options);
                var enjoyhint_script_steps = [
                    {
                        'click #tab-case' : this.$t('Click the "Cases" Tab to Manage Cases'),
                        showSkip: false,
                        scrollAnimationSpeed: 1,
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                    },
                    {
                        selector: '#pane-case .header .case-create',//jquery selector
                        event: 'click',
                        description: this.$t('Click "+" to add new Case'),
                        shape : 'circle',
                        radius: 13,
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                    },
                    {
                        selector: '#pane-case .el-dialog__body .el-form-item:first-child',//jquery selector
                        event_selector: 'click',
                        showNext: true,
                        description: this.$t('Choose a Godchild or press "Next" to Add God Child from the Godchild tab, if its not added'),
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                    },
                    {
                        selector: ' #tab-patenkinder',//jquery selector
                        event: 'click',
                        description: this.$t('Click the tab to Manage GodChild'),
                        showSkip: false,
                        onBeforeStart: function(){
                            //do something
                            this.$refs.cases.dialogFormVisible = false;
                        }.bind(this),
                        scrollAnimationSpeed: 1,
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                    },
                    {
                        selector: '#pane-patenkinder .header .patekinder-create',//jquery selector
                        event: 'click',
                        description: this.$t('Click "+" to add new Godchild'),
                        shape : 'circle',
                        radius: 13,
                        "skipButton" : {className: "", text: this.$t("Get Started")},
                    },
                ];
                //set script config
                this.enjoyhint_instance.set(enjoyhint_script_steps);

                // Below block will only be executed if user is visiting the tour first time.
                if(this.$store.state.config.user.tour_visited == '0') {
                    var user_id = this.$store.state.config.user.id;
                    var user_details = this.$store.state.config.user;
                    user_details.tour_visited = '1';

                    // Update tour visited status on skip button click
                    $('.enjoyhint_skip_btn').on('click', function () {
                        helper.updateTourVisited(user_id).then(() => {
                            
                            this.$store.dispatch("setConfig", {
                                user: user_details
                            });
                        });
                    }.bind(this));

                    // Update tour visited status on next button click
                    $('.enjoyhint_next_btn').on('click', function () {
                        helper.updateTourVisited(user_id).then(() => {
                            this.$store.dispatch("setConfig", {
                                user: user_details
                            });
                        });
                    }.bind(this));
                }

                //run Enjoyhint script
                this.enjoyhint_instance.run();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Layout/Fachstellen/Dashboard.vue